export enum HelpHeaders {
  HowToCreateAutomaton = "How to create automaton",
  HowToDownloadAutomaton = "How to download automaton",
  HowToUploadAutomaton = "How to upload automaton",
  HowToCheckIfAutomatonIsDFA = "How to check if automaton is DFA",
  HowToCheckIfAutomatonIsNFA = "How to check if automaton is NFA",
  HowToHighlightNullTransitions = "How to highlight null transitions on automaton",
  HowToConvertNFAtoDFA = "How to convert NFA to DFA",
  HowToMinimizeDFA = "How to minimize DFA",
  HowToTestAStringOnAutomaton = "How to test a string on automaton",
}
